import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import { Toolbar, Typography, withStyles } from '@material-ui/core';
import Button from './Button';
import HSpacer from './HSpacer';
import SearchInput from './SearchInput';
import classNames from 'classnames';

var styles = function styles(theme) {
  return {
    spacer: {
      flex: '1 1 80%'
    },
    actions: {
      color: theme.palette.text.secondary
    },
    multiSelectRow: {
      backgroundColor: '#FDF6ED',
      fontSize: '14px'
    },
    selectedText: {
      color: '#FF8200' //width: '120px',

    },
    toolbar: {
      minHeight: '36px',
      heigh: '36px',
      marginBottom: '5px',
      padding: 0
    },
    title: {
      width: '100%'
    },
    searchBar: {
      float: 'right'
    }
  };
};

var TableToolbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableToolbar, _React$Component);

  function TableToolbar() {
    _classCallCheck(this, TableToolbar);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableToolbar).apply(this, arguments));
  }

  _createClass(TableToolbar, [{
    key: "render",
    value: function render() {
      // actions needs to be a list of actions
      // { label: 'actionLabel', isEnabled: () => {}, actionCallback: () => {}}
      var _this$props = this.props,
          actions = _this$props.actions,
          multiActions = _this$props.multiActions,
          selected = _this$props.selected,
          classes = _this$props.classes,
          title = _this$props.title,
          search = _this$props.search,
          searchLive = _this$props.searchLive,
          searchFunction = _this$props.searchFunction;
      return React.createElement(React.Fragment, null, (search !== undefined || title !== undefined) && React.createElement(Toolbar, {
        className: classes.toolbar
      }, React.createElement(Typography, {
        variant: 'h2',
        className: classes.title
      }, title), search !== undefined && React.createElement(SearchInput, {
        onTextChange: searchFunction,
        searchLive: searchLive,
        className: classes.searchBar
      })), (actions !== undefined || multiActions !== undefined) && React.createElement(React.Fragment, null, selected.length === 0 && React.createElement(React.Fragment, null, React.createElement(Toolbar, {
        className: classes.toolbar
      }, React.createElement('div', {
        className: classes.spacer
      }), actions !== undefined && actions.map(function (value, index) {
        /**
        * isEnabled can be either a function that returns a boolean
        * or directly a boolean.
        */
        if (value.spacer) {
          return React.createElement(HSpacer, {
            key: 'spacer-' + index,
            medium: true
          });
        }

        var bool = false;

        if (actions.isEnabled === undefined) {
          bool = true;
        } else if (typeof actions.isEnabled === 'boolean') {
          bool = actions.isEnabled;
        } else if (typeof actions.isEnabled === 'function') {
          bool = actions.isEnabled();
        }

        return React.createElement(Button, _extends({
          key: 'toolbar-action-' + index,
          disabled: !bool,
          onClick: value.actionCallback
        }, value.styles, {
          height: '36px',
          width: '110px'
        }), value.label);
      }))), selected.length > 0 && React.createElement(Toolbar, {
        className: classNames(classes.multiSelectRow, classes.toolbar)
      }, React.createElement(Typography, {
        className: classes.selectedText,
        style: {
          marginLeft: '20px'
        }
      }, selected.length, ' items selected'), React.createElement('div', {
        className: classes.spacer
      }), multiActions !== undefined && multiActions.map(function (value, index) {
        var bool = false;
        /**
        * isEnabled can be either a function that returns a boolean
        * a string ('one', 'many') or directly a boolean.
        */

        if (typeof value.isEnabled === 'string') {
          switch (value.isEnabled) {
            case 'one':
              bool = selected.length === 1;
              break;

            case 'many':
              bool = selected.length >= 1;
              break;

            default:
              bool = false;
              break;
          }
        } else if (typeof value.isEnabled === 'function') {
          bool = value.isEnabled(selected);
        } else if (typeof value.isEnabled === 'boolean') {
          bool = value.isEnabled;
        }

        return React.createElement(Button, {
          key: 'selected-toolbar-action-' + index,
          disabled: !bool,
          variant: 'text',
          color: 'primary',
          onClick: function onClick() {
            return value.actionCallback(selected);
          }
        }, value.label);
      }))));
    }
  }]);

  return TableToolbar;
}(React.Component);

;
export default withStyles(styles)(TableToolbar);